<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 11.39 20 16l-8 4.612-8-4.611zm0-.39-8.666 5L12 21l8.667-5z" fill="#14C850" />
    <path d="m20.611 8-8.61 5-8.667-5L12 3z" fill="#14C850" />
    <path d="M12 13.002v4l-8.666-5v-4z" fill="#00A03C" />
    <path d="M12.002 13.002v4l8.611-5v-4z" fill="#008C32" />
  </svg>
</template>
